/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class UserLoginClientServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * userAccountStatus
     * @param userId userId
     * @return OK
     */
    userAccountStatus(userId: string): Promise<ROfLoginStatusDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/client/login/account-status?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUserAccountStatus(_response);
        });
    }

    protected processUserAccountStatus(response: AxiosResponse): Promise<ROfLoginStatusDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfLoginStatusDTO.fromJS(resultData200) : new ROfLoginStatusDTO();
            return result200;
        }
        return Promise.resolve<ROfLoginStatusDTO>(<any>null);
    }

    /**
     * userLoginHandler
     * @param loginHandlerDTO loginHandlerDTO
     * @return OK
     */
    userLoginHandler(loginHandlerDTO: LoginHandlerDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/client/login/login-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginHandlerDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUserLoginHandler(_response);
        });
    }

    protected processUserLoginHandler(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }
}

export class UserServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 新增或修改
     * @param user user
     * @return OK
     */
    create(user: User): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 查看详情
     * @param account (optional) 
     * @param avatar (optional) 
     * @param birthday (optional) 
     * @param code (optional) 
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param deptId (optional) 
     * @param email (optional) 
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param isMiniReportPerson (optional) 
     * @param name (optional) 
     * @param organizationId (optional) 
     * @param password (optional) 
     * @param phone (optional) 
     * @param postId (optional) 
     * @param realName (optional) 
     * @param roleId (optional) 
     * @param sex (optional) 
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    detail(account: string | null | undefined, avatar: string | null | undefined, birthday: Date | null | undefined, code: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, deptId: string | null | undefined, email: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, isMiniReportPerson: number | null | undefined, name: string | null | undefined, organizationId: string | null | undefined, password: string | null | undefined, phone: string | null | undefined, postId: string | null | undefined, realName: string | null | undefined, roleId: string | null | undefined, sex: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/detail?";
        if (account !== undefined)
            url_ += "account=" + encodeURIComponent("" + account) + "&"; 
        if (avatar !== undefined)
            url_ += "avatar=" + encodeURIComponent("" + avatar) + "&"; 
        if (birthday !== undefined)
            url_ += "birthday=" + encodeURIComponent(birthday ? "" + birthday.toJSON() : "") + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (deptId !== undefined)
            url_ += "deptId=" + encodeURIComponent("" + deptId) + "&"; 
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (isMiniReportPerson !== undefined)
            url_ += "isMiniReportPerson=" + encodeURIComponent("" + isMiniReportPerson) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&"; 
        if (postId !== undefined)
            url_ += "postId=" + encodeURIComponent("" + postId) + "&"; 
        if (realName !== undefined)
            url_ += "realName=" + encodeURIComponent("" + realName) + "&"; 
        if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&"; 
        if (sex !== undefined)
            url_ += "sex=" + encodeURIComponent("" + sex) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDetail(_response);
        });
    }

    protected processDetail(response: AxiosResponse): Promise<ROfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfUserVO.fromJS(resultData200) : new ROfUserVO();
            return result200;
        }
        return Promise.resolve<ROfUserVO>(<any>null);
    }

    /**
     * 导出用户
     * @return OK
     */
    exportUser(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/export-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExportUser(_response);
        });
    }

    protected processExportUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 权限设置
     * @param roleIds roleId集合
     * @param userIds userId集合
     * @return OK
     */
    grant(roleIds: string, userIds: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/grant?";
        if (roleIds === undefined || roleIds === null)
            throw new Error("The parameter 'roleIds' must be defined and cannot be null.");
        else
            url_ += "roleIds=" + encodeURIComponent("" + roleIds) + "&"; 
        if (userIds === undefined || userIds === null)
            throw new Error("The parameter 'userIds' must be defined and cannot be null.");
        else
            url_ += "userIds=" + encodeURIComponent("" + userIds) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGrant(_response);
        });
    }

    protected processGrant(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 导入用户
     * @param file (optional) file
     * @param isCovered (optional) isCovered
     * @return OK
     */
    importUser(file: FileParameter | null | undefined, isCovered: number | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/import-user?";
        if (isCovered !== undefined)
            url_ += "isCovered=" + encodeURIComponent("" + isCovered) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processImportUser(_response);
        });
    }

    protected processImportUser(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 查看详情
     * @return OK
     */
    info(): Promise<ROfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processInfo(_response);
        });
    }

    protected processInfo(response: AxiosResponse): Promise<ROfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfUserVO.fromJS(resultData200) : new ROfUserVO();
            return result200;
        }
        return Promise.resolve<ROfUserVO>(<any>null);
    }

    /**
     * 列表
     * @param account (optional) 账号名
     * @param current (optional) 当前页
     * @param realName (optional) 姓名
     * @param size (optional) 每页的数量
     * @return OK
     */
    list(account: string | null | undefined, current: number | null | undefined, realName: string | null | undefined, size: number | null | undefined): Promise<ROfIPageOfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/list?";
        if (account !== undefined)
            url_ += "account=" + encodeURIComponent("" + account) + "&"; 
        if (realName !== undefined)
            url_ += "realName=" + encodeURIComponent("" + realName) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ROfIPageOfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserVO.fromJS(resultData200) : new ROfIPageOfUserVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserVO>(<any>null);
    }

    /**
     * 获取拥有当前职权域得用户
     * @param dataScope 职权域
     * @return OK
     */
    listByDataScope(dataScope: string): Promise<ROfListOfUser> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/list-by-data-scope?";
        if (dataScope === undefined || dataScope === null)
            throw new Error("The parameter 'dataScope' must be defined and cannot be null.");
        else
            url_ += "dataScope=" + encodeURIComponent("" + dataScope) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListByDataScope(_response);
        });
    }

    protected processListByDataScope(response: AxiosResponse): Promise<ROfListOfUser> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfUser.fromJS(resultData200) : new ROfListOfUser();
            return result200;
        }
        return Promise.resolve<ROfListOfUser>(<any>null);
    }

    /**
     * 列表
     * @param account (optional) 账号名
     * @param current (optional) 当前页
     * @param deptId (optional) deptId
     * @param realName (optional) 姓名
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(account: string | null | undefined, current: number | null | undefined, deptId: string | null | undefined, realName: string | null | undefined, size: number | null | undefined): Promise<ROfIPageOfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/page?";
        if (account !== undefined)
            url_ += "account=" + encodeURIComponent("" + account) + "&"; 
        if (realName !== undefined)
            url_ += "realName=" + encodeURIComponent("" + realName) + "&"; 
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (deptId !== undefined)
            url_ += "deptId=" + encodeURIComponent("" + deptId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ROfIPageOfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserVO.fromJS(resultData200) : new ROfIPageOfUserVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserVO>(<any>null);
    }

    /**
     * 第三方注册用户
     * @param account (optional) 
     * @param avatar (optional) 
     * @param birthday (optional) 
     * @param code (optional) 
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param deptId (optional) 
     * @param email (optional) 
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param isMiniReportPerson (optional) 
     * @param name (optional) 
     * @param oauthId (optional) oauthId
     * @param organizationId (optional) 
     * @param password (optional) 
     * @param phone (optional) 
     * @param postId (optional) 
     * @param realName (optional) 
     * @param roleId (optional) 
     * @param sex (optional) 
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    registerGuest(account: string | null | undefined, avatar: string | null | undefined, birthday: Date | null | undefined, code: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, deptId: string | null | undefined, email: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, isMiniReportPerson: number | null | undefined, name: string | null | undefined, oauthId: string | null | undefined, organizationId: string | null | undefined, password: string | null | undefined, phone: string | null | undefined, postId: string | null | undefined, realName: string | null | undefined, roleId: string | null | undefined, sex: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/register-guest?";
        if (account !== undefined)
            url_ += "account=" + encodeURIComponent("" + account) + "&"; 
        if (avatar !== undefined)
            url_ += "avatar=" + encodeURIComponent("" + avatar) + "&"; 
        if (birthday !== undefined)
            url_ += "birthday=" + encodeURIComponent(birthday ? "" + birthday.toJSON() : "") + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (deptId !== undefined)
            url_ += "deptId=" + encodeURIComponent("" + deptId) + "&"; 
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (isMiniReportPerson !== undefined)
            url_ += "isMiniReportPerson=" + encodeURIComponent("" + isMiniReportPerson) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&"; 
        if (postId !== undefined)
            url_ += "postId=" + encodeURIComponent("" + postId) + "&"; 
        if (realName !== undefined)
            url_ += "realName=" + encodeURIComponent("" + realName) + "&"; 
        if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&"; 
        if (sex !== undefined)
            url_ += "sex=" + encodeURIComponent("" + sex) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        if (oauthId !== undefined)
            url_ += "oauthId=" + encodeURIComponent("" + oauthId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRegisterGuest(_response);
        });
    }

    protected processRegisterGuest(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 删除
     * @param ids ids
     * @return OK
     */
    remove(ids: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/remove?";
        if (ids === undefined || ids === null)
            throw new Error("The parameter 'ids' must be defined and cannot be null.");
        else
            url_ += "ids=" + encodeURIComponent("" + ids) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 初始化密码
     * @param userIds userId集合
     * @return OK
     */
    resetPassword(userIds: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/reset-password?";
        if (userIds === undefined || userIds === null)
            throw new Error("The parameter 'userIds' must be defined and cannot be null.");
        else
            url_ += "userIds=" + encodeURIComponent("" + userIds) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 新增或修改
     * @param user user
     * @return OK
     */
    submit(user: User): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改
     * @param user user
     * @return OK
     */
    update(user: User): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改基本信息
     * @param user user
     * @return OK
     */
    updateInfo(user: User): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/update-info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateInfo(_response);
        });
    }

    protected processUpdateInfo(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 修改密码
     * @param newPassword 新密码
     * @param newPassword1 新密码
     * @param oldPassword 旧密码
     * @return OK
     */
    updatePassword(newPassword: string, newPassword1: string, oldPassword: string): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/update-password?";
        if (newPassword === undefined || newPassword === null)
            throw new Error("The parameter 'newPassword' must be defined and cannot be null.");
        else
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&"; 
        if (newPassword1 === undefined || newPassword1 === null)
            throw new Error("The parameter 'newPassword1' must be defined and cannot be null.");
        else
            url_ += "newPassword1=" + encodeURIComponent("" + newPassword1) + "&"; 
        if (oldPassword === undefined || oldPassword === null)
            throw new Error("The parameter 'oldPassword' must be defined and cannot be null.");
        else
            url_ += "oldPassword=" + encodeURIComponent("" + oldPassword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdatePassword(_response);
        });
    }

    protected processUpdatePassword(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 用户列表
     * @param account (optional) 
     * @param avatar (optional) 
     * @param birthday (optional) 
     * @param code (optional) 
     * @param createDept (optional) 创建部门
     * @param createTime (optional) 创建时间
     * @param createUser (optional) 创建人
     * @param deptId (optional) 
     * @param email (optional) 
     * @param id (optional) 主键id
     * @param isDeleted (optional) 是否已删除
     * @param isMiniReportPerson (optional) 
     * @param name (optional) 
     * @param organizationId (optional) 
     * @param password (optional) 
     * @param phone (optional) 
     * @param postId (optional) 
     * @param realName (optional) 
     * @param roleId (optional) 
     * @param sex (optional) 
     * @param status (optional) 业务状态
     * @param tenantId (optional) 租户ID
     * @param updateTime (optional) 更新时间
     * @param updateUser (optional) 更新人
     * @return OK
     */
    userList(account: string | null | undefined, avatar: string | null | undefined, birthday: Date | null | undefined, code: string | null | undefined, createDept: string | null | undefined, createTime: Date | null | undefined, createUser: string | null | undefined, deptId: string | null | undefined, email: string | null | undefined, id: string | null | undefined, isDeleted: number | null | undefined, isMiniReportPerson: number | null | undefined, name: string | null | undefined, organizationId: string | null | undefined, password: string | null | undefined, phone: string | null | undefined, postId: string | null | undefined, realName: string | null | undefined, roleId: string | null | undefined, sex: number | null | undefined, status: number | null | undefined, tenantId: string | null | undefined, updateTime: Date | null | undefined, updateUser: string | null | undefined): Promise<ROfListOfUser> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-list?";
        if (account !== undefined)
            url_ += "account=" + encodeURIComponent("" + account) + "&"; 
        if (avatar !== undefined)
            url_ += "avatar=" + encodeURIComponent("" + avatar) + "&"; 
        if (birthday !== undefined)
            url_ += "birthday=" + encodeURIComponent(birthday ? "" + birthday.toJSON() : "") + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (createDept !== undefined)
            url_ += "createDept=" + encodeURIComponent("" + createDept) + "&"; 
        if (createTime !== undefined)
            url_ += "createTime=" + encodeURIComponent(createTime ? "" + createTime.toJSON() : "") + "&"; 
        if (createUser !== undefined)
            url_ += "createUser=" + encodeURIComponent("" + createUser) + "&"; 
        if (deptId !== undefined)
            url_ += "deptId=" + encodeURIComponent("" + deptId) + "&"; 
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (isDeleted !== undefined)
            url_ += "isDeleted=" + encodeURIComponent("" + isDeleted) + "&"; 
        if (isMiniReportPerson !== undefined)
            url_ += "isMiniReportPerson=" + encodeURIComponent("" + isMiniReportPerson) + "&"; 
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&"; 
        if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        if (phone !== undefined)
            url_ += "phone=" + encodeURIComponent("" + phone) + "&"; 
        if (postId !== undefined)
            url_ += "postId=" + encodeURIComponent("" + postId) + "&"; 
        if (realName !== undefined)
            url_ += "realName=" + encodeURIComponent("" + realName) + "&"; 
        if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&"; 
        if (sex !== undefined)
            url_ += "sex=" + encodeURIComponent("" + sex) + "&"; 
        if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&"; 
        if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&"; 
        if (updateTime !== undefined)
            url_ += "updateTime=" + encodeURIComponent(updateTime ? "" + updateTime.toJSON() : "") + "&"; 
        if (updateUser !== undefined)
            url_ += "updateUser=" + encodeURIComponent("" + updateUser) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUserList(_response);
        });
    }

    protected processUserList(response: AxiosResponse): Promise<ROfListOfUser> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfUser.fromJS(resultData200) : new ROfListOfUser();
            return result200;
        }
        return Promise.resolve<ROfListOfUser>(<any>null);
    }
}

export class ExportUserServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出模板
     * @return OK
     */
    1(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/export-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class MasterlinkUserServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * page
     * @param current (optional) 当前页
     * @param deptId (optional) deptId
     * @param key (optional) key
     * @param size (optional) 每页的数量
     * @return OK
     */
    page(current: number | null | undefined, deptId: string | null | undefined, key: string | null | undefined, size: number | null | undefined): Promise<ROfIPageOfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/m-user/page?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (deptId !== undefined)
            url_ += "deptId=" + encodeURIComponent("" + deptId) + "&"; 
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ROfIPageOfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserVO.fromJS(resultData200) : new ROfIPageOfUserVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserVO>(<any>null);
    }

    /**
     * pageHasEmail
     * @param current (optional) 当前页
     * @param deptId (optional) deptId
     * @param key (optional) key
     * @param size (optional) 每页的数量
     * @return OK
     */
    pageHasEmail(current: number | null | undefined, deptId: string | null | undefined, key: string | null | undefined, size: number | null | undefined): Promise<ROfIPageOfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/m-user/pageHasEmail?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        if (deptId !== undefined)
            url_ += "deptId=" + encodeURIComponent("" + deptId) + "&"; 
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPageHasEmail(_response);
        });
    }

    protected processPageHasEmail(response: AxiosResponse): Promise<ROfIPageOfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserVO.fromJS(resultData200) : new ROfIPageOfUserVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserVO>(<any>null);
    }

    /**
     * 获取处理执行人岗位的用户列表
     * @param processPostUserDTO processPostUserDTO
     * @return OK
     */
    getProcessPostUserList(processPostUserDTO: ProcessPostUserDTO): Promise<ROfListOfUser> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/m-user/process-post-user-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processPostUserDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetProcessPostUserList(_response);
        });
    }

    protected processGetProcessPostUserList(response: AxiosResponse): Promise<ROfListOfUser> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfUser.fromJS(resultData200) : new ROfListOfUser();
            return result200;
        }
        return Promise.resolve<ROfListOfUser>(<any>null);
    }
}

export class RoleUserRelationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 角色绑定账号
     * @param idListIDto (optional) 账号id集合
     * @param roleId (optional) 角色Id
     * @return OK
     */
    roleBindUsers(idListIDto: IdListInDto | null | undefined, roleId: string | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/masterlink-role-user/{roleId}/add-user-list";
        if (roleId !== null && roleId !== undefined)
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        else
            url_ = url_.replace("/{roleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idListIDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRoleBindUsers(_response);
        });
    }

    protected processRoleBindUsers(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 角色移除账号
     * @param idListIDto (optional) 账号id集合
     * @param roleId (optional) 角色Id
     * @return OK
     */
    removeUserList(idListIDto: IdListInDto | null | undefined, roleId: string | null | undefined): Promise<R> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/masterlink-role-user/{roleId}/remove-user-list";
        if (roleId !== null && roleId !== undefined)
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        else
            url_ = url_.replace("/{roleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(idListIDto);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRemoveUserList(_response);
        });
    }

    protected processRemoveUserList(response: AxiosResponse): Promise<R> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? R.fromJS(resultData200) : new R();
            return result200;
        }
        return Promise.resolve<R>(<any>null);
    }

    /**
     * 查询角色下关联的账号
     * @param roleId (optional) 角色Id
     * @return OK
     */
    userList(roleId: string | null | undefined): Promise<ROfListOfUserDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/masterlink-role-user/{roleId}/user-list";
        if (roleId !== null && roleId !== undefined)
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId)); 
        else
            url_ = url_.replace("/{roleId}", "");
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUserList(_response);
        });
    }

    protected processUserList(response: AxiosResponse): Promise<ROfListOfUserDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfListOfUserDto.fromJS(resultData200) : new ROfListOfUserDto();
            return result200;
        }
        return Promise.resolve<ROfListOfUserDto>(<any>null);
    }
}

export class OauthDetailServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 绑定社交账号
     * @param code (optional) code
     * @param state (optional) state
     * @return OK
     */
    bindSocial(code: string | null | undefined, state: string | null | undefined): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/social/bind?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processBindSocial(_response);
        });
    }

    protected processBindSocial(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 解绑社交账号
     * @param type (optional) type
     * @return OK
     */
    unbindSocial(type: string | null | undefined): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/social/unbind?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUnbindSocial(_response);
        });
    }

    protected processUnbindSocial(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }
}

export class ServiceRouteServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    listRoutes(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListRoutes(_response);
        });
    }

    protected processListRoutes(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class ListRoutesServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * listRoutes
     * @return OK
     */
    1(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "HEAD",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process1(_response);
        });
    }

    protected process1(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    2(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process2(_response);
        });
    }

    protected process2(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    3(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process3(_response);
        });
    }

    protected process3(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    5(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process5(_response);
        });
    }

    protected process5(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    6(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "OPTIONS",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process6(_response);
        });
    }

    protected process6(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }

    /**
     * listRoutes
     * @return OK
     */
    4(): Promise<ServiceRouteInfo> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/sop/routes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.process4(_response);
        });
    }

    protected process4(response: AxiosResponse): Promise<ServiceRouteInfo> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServiceRouteInfo.fromJS(resultData200) : new ServiceRouteInfo();
            return result200;
        }
        return Promise.resolve<ServiceRouteInfo>(<any>null);
    }
}

export class UserLoginServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 导出查询登陆日志
     * @param userLoginDTO userLoginDTO
     * @return OK
     */
    export(userLoginDTO: UserLoginDTO): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-login/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLoginDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * 分页查询登陆日志
     * @param userLoginDTO userLoginDTO
     * @return OK
     */
    page(userLoginDTO: UserLoginDTO): Promise<ROfIPageOfUserLoginOutDTO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-login/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLoginDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPage(_response);
        });
    }

    protected processPage(response: AxiosResponse): Promise<ROfIPageOfUserLoginOutDTO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserLoginOutDTO.fromJS(resultData200) : new ROfIPageOfUserLoginOutDTO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserLoginOutDTO>(<any>null);
    }
}

export class UserOrganizationServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 为指定组织机构下添加用户
     * @param addDTO addDTO
     * @return OK
     */
    saveOrganizationUsers(addDTO: OrganizationUserAdjustDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveOrganizationUsers(_response);
        });
    }

    protected processSaveOrganizationUsers(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 删除组织机构下用户
     * @param delDTO delDTO
     * @return OK
     */
    deleteOrganizationUsers(delDTO: OrganizationUserAdjustDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(delDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeleteOrganizationUsers(_response);
        });
    }

    protected processDeleteOrganizationUsers(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 获取不属于组织结构下的人员列表
     * @param current (optional) 当前页
     * @param queryDTO queryDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getNotExistUsersForOrganization(current: number | null | undefined, queryDTO: OrganizationUserQueryDTO, size: number | null | undefined): Promise<ROfIPageOfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-organization/getOrganizationNotExistUser?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNotExistUsersForOrganization(_response);
        });
    }

    protected processGetNotExistUsersForOrganization(response: AxiosResponse): Promise<ROfIPageOfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserVO.fromJS(resultData200) : new ROfIPageOfUserVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserVO>(<any>null);
    }

    /**
     * 获取组织机构下的人员列表
     * @param current (optional) 当前页
     * @param queryDTO queryDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getUsersForOrganization(current: number | null | undefined, queryDTO: OrganizationUserQueryDTO, size: number | null | undefined): Promise<ROfIPageOfUserPostVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-organization/getOrganizationUser?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUsersForOrganization(_response);
        });
    }

    protected processGetUsersForOrganization(response: AxiosResponse): Promise<ROfIPageOfUserPostVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserPostVO.fromJS(resultData200) : new ROfIPageOfUserPostVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserPostVO>(<any>null);
    }
}

export class UserPostServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * 删除岗位下用户
     * @param addDTO addDTO
     * @return OK
     */
    deletePostUsers(addDTO: PostUserAdjustDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-post/deletePostUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDeletePostUsers(_response);
        });
    }

    protected processDeletePostUsers(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }

    /**
     * 获取不属于岗位下的人员列表
     * @param current (optional) 当前页
     * @param queryDTO queryDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getNotExistUsersForPost(current: number | null | undefined, queryDTO: PostUserQueryDTO, size: number | null | undefined): Promise<ROfIPageOfUserVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-post/getPostNotExistUser?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetNotExistUsersForPost(_response);
        });
    }

    protected processGetNotExistUsersForPost(response: AxiosResponse): Promise<ROfIPageOfUserVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserVO.fromJS(resultData200) : new ROfIPageOfUserVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserVO>(<any>null);
    }

    /**
     * 获取岗位下的人员列表
     * @param current (optional) 当前页
     * @param queryDTO queryDTO
     * @param size (optional) 每页的数量
     * @return OK
     */
    getUsersForPost(current: number | null | undefined, queryDTO: PostUserQueryDTO, size: number | null | undefined): Promise<ROfIPageOfUserPostVO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-post/getPostUser?";
        if (current !== undefined)
            url_ += "current=" + encodeURIComponent("" + current) + "&"; 
        if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetUsersForPost(_response);
        });
    }

    protected processGetUsersForPost(response: AxiosResponse): Promise<ROfIPageOfUserPostVO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfIPageOfUserPostVO.fromJS(resultData200) : new ROfIPageOfUserPostVO();
            return result200;
        }
        return Promise.resolve<ROfIPageOfUserPostVO>(<any>null);
    }

    /**
     * 为指定岗位下添加用户
     * @param addDTO addDTO
     * @return OK
     */
    savePostUsers(addDTO: PostUserAdjustDTO): Promise<ROfboolean> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.251:31080/blade-user')+ "/user-post/savePostUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addDTO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSavePostUsers(_response);
        });
    }

    protected processSavePostUsers(response: AxiosResponse): Promise<ROfboolean> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfboolean.fromJS(resultData200) : new ROfboolean();
            return result200;
        }
        return Promise.resolve<ROfboolean>(<any>null);
    }
}

export class GatewayFilterDefinition implements IGatewayFilterDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayFilterDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayFilterDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayFilterDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayFilterDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class GatewayPredicateDefinition implements IGatewayPredicateDefinition {
    args!: { [key: string] : string; } | undefined;
    name!: string | undefined;

    constructor(data?: IGatewayPredicateDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["args"]) {
                this.args = {} as any;
                for (let key in data["args"]) {
                    if (data["args"].hasOwnProperty(key))
                        this.args![key] = data["args"][key];
                }
            }
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GatewayPredicateDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new GatewayPredicateDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.args) {
            data["args"] = {};
            for (let key in this.args) {
                if (this.args.hasOwnProperty(key))
                    data["args"][key] = this.args[key];
            }
        }
        data["name"] = this.name;
        return data; 
    }
}

export interface IGatewayPredicateDefinition {
    args: { [key: string] : string; } | undefined;
    name: string | undefined;
}

export class IPageOfUserLoginOutDTO implements IIPageOfUserLoginOutDTO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: UserLoginOutDTO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfUserLoginOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(UserLoginOutDTO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfUserLoginOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfUserLoginOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfUserLoginOutDTO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: UserLoginOutDTO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfUserPostVO implements IIPageOfUserPostVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: UserPostVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfUserPostVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(UserPostVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfUserPostVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfUserPostVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfUserPostVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: UserPostVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IPageOfUserVO implements IIPageOfUserVO {
    current!: string | undefined;
    hitCount!: boolean | undefined;
    pages!: string | undefined;
    records!: UserVO[] | undefined;
    searchCount!: boolean | undefined;
    size!: string | undefined;
    total!: string | undefined;

    constructor(data?: IIPageOfUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.hitCount = data["hitCount"];
            this.pages = data["pages"];
            if (data["records"] && data["records"].constructor === Array) {
                this.records = [] as any;
                for (let item of data["records"])
                    this.records!.push(UserVO.fromJS(item));
            }
            this.searchCount = data["searchCount"];
            this.size = data["size"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): IPageOfUserVO {
        data = typeof data === 'object' ? data : {};
        let result = new IPageOfUserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["hitCount"] = this.hitCount;
        data["pages"] = this.pages;
        if (this.records && this.records.constructor === Array) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["searchCount"] = this.searchCount;
        data["size"] = this.size;
        data["total"] = this.total;
        return data; 
    }
}

export interface IIPageOfUserVO {
    current: string | undefined;
    hitCount: boolean | undefined;
    pages: string | undefined;
    records: UserVO[] | undefined;
    searchCount: boolean | undefined;
    size: string | undefined;
    total: string | undefined;
}

export class IdListInDto implements IIdListInDto {
    /** Id集合 */
    ids!: string[] | undefined;

    constructor(data?: IIdListInDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): IdListInDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdListInDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IIdListInDto {
    /** Id集合 */
    ids: string[] | undefined;
}

export class LoginHandlerDTO implements ILoginHandlerDTO {
    handlerDate!: Date | undefined;
    loginStatus!: boolean | undefined;
    remoteIp!: string | undefined;
    userAgent!: string | undefined;
    userId!: string | undefined;

    constructor(data?: ILoginHandlerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.handlerDate = data["handlerDate"] ? new Date(data["handlerDate"].toString()) : <any>undefined;
            this.loginStatus = data["loginStatus"];
            this.remoteIp = data["remoteIp"];
            this.userAgent = data["userAgent"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): LoginHandlerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoginHandlerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["handlerDate"] = this.handlerDate ? this.handlerDate.toISOString() : <any>undefined;
        data["loginStatus"] = this.loginStatus;
        data["remoteIp"] = this.remoteIp;
        data["userAgent"] = this.userAgent;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface ILoginHandlerDTO {
    handlerDate: Date | undefined;
    loginStatus: boolean | undefined;
    remoteIp: string | undefined;
    userAgent: string | undefined;
    userId: string | undefined;
}

export class LoginStatusDTO implements ILoginStatusDTO {
    accountNonLocked!: boolean | undefined;
    missNumbers!: number | undefined;

    constructor(data?: ILoginStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNonLocked = data["accountNonLocked"];
            this.missNumbers = data["missNumbers"];
        }
    }

    static fromJS(data: any): LoginStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LoginStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNonLocked"] = this.accountNonLocked;
        data["missNumbers"] = this.missNumbers;
        return data; 
    }
}

export interface ILoginStatusDTO {
    accountNonLocked: boolean | undefined;
    missNumbers: number | undefined;
}

export class OrganizationUserAdjustDTO implements IOrganizationUserAdjustDTO {
    /** 组织结构Id */
    organizationId!: string | undefined;
    /** 选择用户Id集合 */
    userIdList!: string[] | undefined;

    constructor(data?: IOrganizationUserAdjustDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.organizationId = data["organizationId"];
            if (data["userIdList"] && data["userIdList"].constructor === Array) {
                this.userIdList = [] as any;
                for (let item of data["userIdList"])
                    this.userIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): OrganizationUserAdjustDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserAdjustDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationId"] = this.organizationId;
        if (this.userIdList && this.userIdList.constructor === Array) {
            data["userIdList"] = [];
            for (let item of this.userIdList)
                data["userIdList"].push(item);
        }
        return data; 
    }
}

export interface IOrganizationUserAdjustDTO {
    /** 组织结构Id */
    organizationId: string | undefined;
    /** 选择用户Id集合 */
    userIdList: string[] | undefined;
}

export class OrganizationUserQueryDTO implements IOrganizationUserQueryDTO {
    /** 关键词: 筛选用户名，账号，真实姓名模糊匹配 */
    keyValue!: string | undefined;
    /** 组织Id */
    organizationId!: string | undefined;

    constructor(data?: IOrganizationUserQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyValue = data["keyValue"];
            this.organizationId = data["organizationId"];
        }
    }

    static fromJS(data: any): OrganizationUserQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUserQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyValue"] = this.keyValue;
        data["organizationId"] = this.organizationId;
        return data; 
    }
}

export interface IOrganizationUserQueryDTO {
    /** 关键词: 筛选用户名，账号，真实姓名模糊匹配 */
    keyValue: string | undefined;
    /** 组织Id */
    organizationId: string | undefined;
}

export class PostUserAdjustDTO implements IPostUserAdjustDTO {
    /** 岗位Id */
    postId!: string | undefined;
    /** 选择用户Id集合 */
    userIdList!: string[] | undefined;

    constructor(data?: IPostUserAdjustDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.postId = data["postId"];
            if (data["userIdList"] && data["userIdList"].constructor === Array) {
                this.userIdList = [] as any;
                for (let item of data["userIdList"])
                    this.userIdList!.push(item);
            }
        }
    }

    static fromJS(data: any): PostUserAdjustDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PostUserAdjustDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postId"] = this.postId;
        if (this.userIdList && this.userIdList.constructor === Array) {
            data["userIdList"] = [];
            for (let item of this.userIdList)
                data["userIdList"].push(item);
        }
        return data; 
    }
}

export interface IPostUserAdjustDTO {
    /** 岗位Id */
    postId: string | undefined;
    /** 选择用户Id集合 */
    userIdList: string[] | undefined;
}

export class PostUserQueryDTO implements IPostUserQueryDTO {
    /** 关键词: 筛选用户名，账号，真实姓名模糊匹配 */
    keyValue!: string | undefined;
    /** 岗位Id */
    postId!: string | undefined;

    constructor(data?: IPostUserQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyValue = data["keyValue"];
            this.postId = data["postId"];
        }
    }

    static fromJS(data: any): PostUserQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PostUserQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyValue"] = this.keyValue;
        data["postId"] = this.postId;
        return data; 
    }
}

export interface IPostUserQueryDTO {
    /** 关键词: 筛选用户名，账号，真实姓名模糊匹配 */
    keyValue: string | undefined;
    /** 岗位Id */
    postId: string | undefined;
}

export class ProcessPostUserDTO implements IProcessPostUserDTO {
    /** 职权域 */
    dataScope!: string | undefined;
    /** 用户名 */
    name!: string | undefined;

    constructor(data?: IProcessPostUserDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataScope = data["dataScope"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): ProcessPostUserDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessPostUserDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataScope"] = this.dataScope;
        data["name"] = this.name;
        return data; 
    }
}

export interface IProcessPostUserDTO {
    /** 职权域 */
    dataScope: string | undefined;
    /** 用户名 */
    name: string | undefined;
}

/** 查询条件 */
export class Query implements IQuery {
    /** 当前页 */
    current!: number | undefined;
    /** 每页的数量 */
    size!: number | undefined;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.size = data["size"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["size"] = this.size;
        return data; 
    }
}

/** 查询条件 */
export interface IQuery {
    /** 当前页 */
    current: number | undefined;
    /** 每页的数量 */
    size: number | undefined;
}

/** 返回信息 */
export class R implements IR {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: any | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IR) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): R {
        data = typeof data === 'object' ? data : {};
        let result = new R();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IR {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: any | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfUserLoginOutDTO implements IROfIPageOfUserLoginOutDTO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfUserLoginOutDTO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfUserLoginOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfUserLoginOutDTO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfUserLoginOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfUserLoginOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfUserLoginOutDTO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfUserLoginOutDTO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfUserPostVO implements IROfIPageOfUserPostVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfUserPostVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfUserPostVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfUserPostVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfUserPostVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfUserPostVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfUserPostVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfUserPostVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfIPageOfUserVO implements IROfIPageOfUserVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: IPageOfUserVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfIPageOfUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? IPageOfUserVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfIPageOfUserVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfIPageOfUserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfIPageOfUserVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: IPageOfUserVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfUser implements IROfListOfUser {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: User[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(User.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfUser {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfUser {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: User[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfListOfUserDto implements IROfListOfUserDto {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: UserDto[] | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfListOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            if (data["data"] && data["data"].constructor === Array) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(UserDto.fromJS(item));
            }
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfListOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ROfListOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        if (this.data && this.data.constructor === Array) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfListOfUserDto {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: UserDto[] | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfLoginStatusDTO implements IROfLoginStatusDTO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: LoginStatusDTO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfLoginStatusDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? LoginStatusDTO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfLoginStatusDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfLoginStatusDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfLoginStatusDTO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: LoginStatusDTO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfUserVO implements IROfUserVO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: UserVO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? UserVO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfUserVO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfUserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfUserVO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: UserVO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

/** 返回信息 */
export class ROfboolean implements IROfboolean {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: boolean | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfboolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"];
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfboolean {
        data = typeof data === 'object' ? data : {};
        let result = new ROfboolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfboolean {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: boolean | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class RouteDefinition implements IRouteDefinition {
    compatibleMode!: number | undefined;
    filters!: GatewayFilterDefinition[] | undefined;
    id!: string | undefined;
    ignoreValidate!: number | undefined;
    mergeResult!: number | undefined;
    name!: string | undefined;
    needToken!: number | undefined;
    order!: number | undefined;
    path!: string | undefined;
    permission!: number | undefined;
    predicates!: GatewayPredicateDefinition[] | undefined;
    status!: number | undefined;
    uri!: string | undefined;
    version!: string | undefined;

    constructor(data?: IRouteDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.compatibleMode = data["compatibleMode"];
            if (data["filters"] && data["filters"].constructor === Array) {
                this.filters = [] as any;
                for (let item of data["filters"])
                    this.filters!.push(GatewayFilterDefinition.fromJS(item));
            }
            this.id = data["id"];
            this.ignoreValidate = data["ignoreValidate"];
            this.mergeResult = data["mergeResult"];
            this.name = data["name"];
            this.needToken = data["needToken"];
            this.order = data["order"];
            this.path = data["path"];
            this.permission = data["permission"];
            if (data["predicates"] && data["predicates"].constructor === Array) {
                this.predicates = [] as any;
                for (let item of data["predicates"])
                    this.predicates!.push(GatewayPredicateDefinition.fromJS(item));
            }
            this.status = data["status"];
            this.uri = data["uri"];
            this.version = data["version"];
        }
    }

    static fromJS(data: any): RouteDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new RouteDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["compatibleMode"] = this.compatibleMode;
        if (this.filters && this.filters.constructor === Array) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["ignoreValidate"] = this.ignoreValidate;
        data["mergeResult"] = this.mergeResult;
        data["name"] = this.name;
        data["needToken"] = this.needToken;
        data["order"] = this.order;
        data["path"] = this.path;
        data["permission"] = this.permission;
        if (this.predicates && this.predicates.constructor === Array) {
            data["predicates"] = [];
            for (let item of this.predicates)
                data["predicates"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["uri"] = this.uri;
        data["version"] = this.version;
        return data; 
    }
}

export interface IRouteDefinition {
    compatibleMode: number | undefined;
    filters: GatewayFilterDefinition[] | undefined;
    id: string | undefined;
    ignoreValidate: number | undefined;
    mergeResult: number | undefined;
    name: string | undefined;
    needToken: number | undefined;
    order: number | undefined;
    path: string | undefined;
    permission: number | undefined;
    predicates: GatewayPredicateDefinition[] | undefined;
    status: number | undefined;
    uri: string | undefined;
    version: string | undefined;
}

export class ServiceRouteInfo implements IServiceRouteInfo {
    createTime!: Date | undefined;
    description!: string | undefined;
    routeDefinitionList!: RouteDefinition[] | undefined;
    serviceId!: string | undefined;
    updateTime!: Date | undefined;

    constructor(data?: IServiceRouteInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.description = data["description"];
            if (data["routeDefinitionList"] && data["routeDefinitionList"].constructor === Array) {
                this.routeDefinitionList = [] as any;
                for (let item of data["routeDefinitionList"])
                    this.routeDefinitionList!.push(RouteDefinition.fromJS(item));
            }
            this.serviceId = data["serviceId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceRouteInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRouteInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["description"] = this.description;
        if (this.routeDefinitionList && this.routeDefinitionList.constructor === Array) {
            data["routeDefinitionList"] = [];
            for (let item of this.routeDefinitionList)
                data["routeDefinitionList"].push(item.toJSON());
        }
        data["serviceId"] = this.serviceId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IServiceRouteInfo {
    createTime: Date | undefined;
    description: string | undefined;
    routeDefinitionList: RouteDefinition[] | undefined;
    serviceId: string | undefined;
    updateTime: Date | undefined;
}

export class User implements IUser {
    account!: string | undefined;
    avatar!: string | undefined;
    birthday!: Date | undefined;
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    deptId!: string | undefined;
    email!: string | undefined;
    /** 主键id */
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    isMiniReportPerson!: number | undefined;
    name!: string | undefined;
    organizationId!: string | undefined;
    password!: string | undefined;
    phone!: string | undefined;
    postId!: string | undefined;
    realName!: string | undefined;
    roleId!: string | undefined;
    sex!: number | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"];
            this.avatar = data["avatar"];
            this.birthday = data["birthday"] ? new Date(data["birthday"].toString()) : <any>undefined;
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.deptId = data["deptId"];
            this.email = data["email"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isMiniReportPerson = data["isMiniReportPerson"];
            this.name = data["name"];
            this.organizationId = data["organizationId"];
            this.password = data["password"];
            this.phone = data["phone"];
            this.postId = data["postId"];
            this.realName = data["realName"];
            this.roleId = data["roleId"];
            this.sex = data["sex"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["avatar"] = this.avatar;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["deptId"] = this.deptId;
        data["email"] = this.email;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isMiniReportPerson"] = this.isMiniReportPerson;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["password"] = this.password;
        data["phone"] = this.phone;
        data["postId"] = this.postId;
        data["realName"] = this.realName;
        data["roleId"] = this.roleId;
        data["sex"] = this.sex;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IUser {
    account: string | undefined;
    avatar: string | undefined;
    birthday: Date | undefined;
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    deptId: string | undefined;
    email: string | undefined;
    /** 主键id */
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    isMiniReportPerson: number | undefined;
    name: string | undefined;
    organizationId: string | undefined;
    password: string | undefined;
    phone: string | undefined;
    postId: string | undefined;
    realName: string | undefined;
    roleId: string | undefined;
    sex: number | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

export class UserDto implements IUserDto {
    /** 头像 */
    avatar!: string | undefined;
    /** 用户主键 */
    id!: string | undefined;
    /** 昵称 */
    name!: string | undefined;
    /** 真名 */
    realName!: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avatar = data["avatar"];
            this.id = data["id"];
            this.name = data["name"];
            this.realName = data["realName"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatar"] = this.avatar;
        data["id"] = this.id;
        data["name"] = this.name;
        data["realName"] = this.realName;
        return data; 
    }
}

export interface IUserDto {
    /** 头像 */
    avatar: string | undefined;
    /** 用户主键 */
    id: string | undefined;
    /** 昵称 */
    name: string | undefined;
    /** 真名 */
    realName: string | undefined;
}

export class UserLoginDTO implements IUserLoginDTO {
    endDate!: Date | undefined;
    query!: Query | undefined;
    startDate!: Date | undefined;
    userId!: string | undefined;

    constructor(data?: IUserLoginDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : <any>undefined;
            this.query = data["query"] ? Query.fromJS(data["query"]) : <any>undefined;
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : <any>undefined;
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UserLoginDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["query"] = this.query ? this.query.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUserLoginDTO {
    endDate: Date | undefined;
    query: Query | undefined;
    startDate: Date | undefined;
    userId: string | undefined;
}

export class UserLoginOutDTO implements IUserLoginOutDTO {
    account!: string | undefined;
    operation!: string | undefined;
    operationTime!: Date | undefined;
    userId!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IUserLoginOutDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"];
            this.operation = data["operation"];
            this.operationTime = data["operationTime"] ? new Date(data["operationTime"].toString()) : <any>undefined;
            this.userId = data["userId"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): UserLoginOutDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginOutDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["operation"] = this.operation;
        data["operationTime"] = this.operationTime ? this.operationTime.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data; 
    }
}

export interface IUserLoginOutDTO {
    account: string | undefined;
    operation: string | undefined;
    operationTime: Date | undefined;
    userId: string | undefined;
    userName: string | undefined;
}

export class UserPostVO implements IUserPostVO {
    /** 账号 */
    account!: string | undefined;
    /** 用户编号 */
    code!: string | undefined;
    /** 昵称 */
    name!: string | undefined;
    /** 所属部门 */
    organizationName!: string | undefined;
    /** 岗位 */
    postName!: string | undefined;
    /** 用户姓名 */
    realName!: string | undefined;
    /** 用户id */
    userId!: string | undefined;

    constructor(data?: IUserPostVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"];
            this.code = data["code"];
            this.name = data["name"];
            this.organizationName = data["organizationName"];
            this.postName = data["postName"];
            this.realName = data["realName"];
            this.userId = data["userId"];
        }
    }

    static fromJS(data: any): UserPostVO {
        data = typeof data === 'object' ? data : {};
        let result = new UserPostVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["code"] = this.code;
        data["name"] = this.name;
        data["organizationName"] = this.organizationName;
        data["postName"] = this.postName;
        data["realName"] = this.realName;
        data["userId"] = this.userId;
        return data; 
    }
}

export interface IUserPostVO {
    /** 账号 */
    account: string | undefined;
    /** 用户编号 */
    code: string | undefined;
    /** 昵称 */
    name: string | undefined;
    /** 所属部门 */
    organizationName: string | undefined;
    /** 岗位 */
    postName: string | undefined;
    /** 用户姓名 */
    realName: string | undefined;
    /** 用户id */
    userId: string | undefined;
}

export class UserVO implements IUserVO {
    account!: string | undefined;
    avatar!: string | undefined;
    birthday!: Date | undefined;
    code!: string | undefined;
    /** 创建部门 */
    createDept!: string | undefined;
    /** 创建时间 */
    createTime!: Date | undefined;
    /** 创建人 */
    createUser!: string | undefined;
    deptId!: string | undefined;
    deptName!: string | undefined;
    email!: string | undefined;
    id!: string | undefined;
    /** 是否已删除 */
    isDeleted!: number | undefined;
    isMiniReportPerson!: number | undefined;
    name!: string | undefined;
    organizationId!: string | undefined;
    password!: string | undefined;
    phone!: string | undefined;
    postId!: string | undefined;
    postName!: string | undefined;
    realName!: string | undefined;
    roleId!: string | undefined;
    roleName!: string | undefined;
    sex!: number | undefined;
    sexName!: string | undefined;
    /** 业务状态 */
    status!: number | undefined;
    /** 租户ID */
    tenantId!: string | undefined;
    tenantName!: string | undefined;
    /** 更新时间 */
    updateTime!: Date | undefined;
    /** 更新人 */
    updateUser!: string | undefined;

    constructor(data?: IUserVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.account = data["account"];
            this.avatar = data["avatar"];
            this.birthday = data["birthday"] ? new Date(data["birthday"].toString()) : <any>undefined;
            this.code = data["code"];
            this.createDept = data["createDept"];
            this.createTime = data["createTime"] ? new Date(data["createTime"].toString()) : <any>undefined;
            this.createUser = data["createUser"];
            this.deptId = data["deptId"];
            this.deptName = data["deptName"];
            this.email = data["email"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isMiniReportPerson = data["isMiniReportPerson"];
            this.name = data["name"];
            this.organizationId = data["organizationId"];
            this.password = data["password"];
            this.phone = data["phone"];
            this.postId = data["postId"];
            this.postName = data["postName"];
            this.realName = data["realName"];
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.sex = data["sex"];
            this.sexName = data["sexName"];
            this.status = data["status"];
            this.tenantId = data["tenantId"];
            this.tenantName = data["tenantName"];
            this.updateTime = data["updateTime"] ? new Date(data["updateTime"].toString()) : <any>undefined;
            this.updateUser = data["updateUser"];
        }
    }

    static fromJS(data: any): UserVO {
        data = typeof data === 'object' ? data : {};
        let result = new UserVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account;
        data["avatar"] = this.avatar;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["code"] = this.code;
        data["createDept"] = this.createDept;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["createUser"] = this.createUser;
        data["deptId"] = this.deptId;
        data["deptName"] = this.deptName;
        data["email"] = this.email;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isMiniReportPerson"] = this.isMiniReportPerson;
        data["name"] = this.name;
        data["organizationId"] = this.organizationId;
        data["password"] = this.password;
        data["phone"] = this.phone;
        data["postId"] = this.postId;
        data["postName"] = this.postName;
        data["realName"] = this.realName;
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["sex"] = this.sex;
        data["sexName"] = this.sexName;
        data["status"] = this.status;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["updateTime"] = this.updateTime ? this.updateTime.toISOString() : <any>undefined;
        data["updateUser"] = this.updateUser;
        return data; 
    }
}

export interface IUserVO {
    account: string | undefined;
    avatar: string | undefined;
    birthday: Date | undefined;
    code: string | undefined;
    /** 创建部门 */
    createDept: string | undefined;
    /** 创建时间 */
    createTime: Date | undefined;
    /** 创建人 */
    createUser: string | undefined;
    deptId: string | undefined;
    deptName: string | undefined;
    email: string | undefined;
    id: string | undefined;
    /** 是否已删除 */
    isDeleted: number | undefined;
    isMiniReportPerson: number | undefined;
    name: string | undefined;
    organizationId: string | undefined;
    password: string | undefined;
    phone: string | undefined;
    postId: string | undefined;
    postName: string | undefined;
    realName: string | undefined;
    roleId: string | undefined;
    roleName: string | undefined;
    sex: number | undefined;
    sexName: string | undefined;
    /** 业务状态 */
    status: number | undefined;
    /** 租户ID */
    tenantId: string | undefined;
    tenantName: string | undefined;
    /** 更新时间 */
    updateTime: Date | undefined;
    /** 更新人 */
    updateUser: string | undefined;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}